import { render } from "./HeaderParent.vue?vue&type=template&id=7c34afc8&scoped=true"
import script from "./HeaderParent.vue?vue&type=script&lang=js"
export * from "./HeaderParent.vue?vue&type=script&lang=js"

import "./HeaderParent.vue?vue&type=style&index=0&id=7c34afc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c34afc8"]])

export default __exports__